export default __webpack_public_path__ + "static/media/advicegradissuegfx-10.1517be8b.png";